import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import HomePage from "./pages/home/HomePage";
import MedtechPage from "./pages/services/MedtechPage";
import AIPage from "./pages/services/AIPage";
import EnterprisePage from "./pages/services/EnterprisePage";
import SoftwareAgencyPage from "./pages/services/SoftwareAgencyPage";
import CaseStudiesPage from "./pages/case-studies/CaseStudiesPage";
import AboutPage from "./pages/about/AboutPage";
import ContactPage from "./pages/contact/ContactPage";
import PrivacyPage from './pages/privacy/PrivacyPage';
import CookiesPage from './pages/cookies/CookiesPage';
import CookieConsent from './components/CookieConsent/CookieConsent';
import CalculatorPage from './pages/calculator/CalculatorPage';
import { LanguageProvider } from './context/LanguageContext';
import { useAnalytics } from './hooks/useAnalytics';
import { initConsentMode } from './utils/googleAnalytics';

// Component to handle analytics tracking
const AnalyticsTracker = () => {
  useAnalytics();
  return null;
};

function App() {
  // Initialize consent mode as early as possible
  useEffect(() => {
    initConsentMode();
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <AnalyticsTracker />
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/uslugi/medtech' element={<MedtechPage />} />
          <Route path='/uslugi/ai' element={<AIPage />} />
          <Route path='/uslugi/enterprise' element={<EnterprisePage />} />
          <Route path='/uslugi/software-agency' element={<SoftwareAgencyPage />} />
          <Route path='/realizacje' element={<CaseStudiesPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/privacy' element={<PrivacyPage />} />
          <Route path='/cookies' element={<CookiesPage />} />
          <Route path='/calculator' element={<CalculatorPage />} />
          {/* Catch-all route for non-existent pages - redirect to home */}
          <Route path='*' element={<Navigate to="/" replace />} />
        </Routes>
        <CookieConsent />
      </Router>
    </LanguageProvider>
  );
}

export default App;
